import { useContext } from 'react';
import {
  onFetchCurrentVersion as onFetchVersion,
  regionedAppHostUrl,
} from './utils';
import { ClientAuthContext } from './ClientAuthProvider';

export const loginWithRedirect = () => {
  window.location.href = regionedAppHostUrl(true);
};

export const useFetchUser = () => {
  const context = useContext(ClientAuthContext);
  return {
    user: context.user,
    isLoggedIn: context.isLoggedIn,
    onLogout: context.onLogout,
    loading: context.loading,
  };
};

export const useFetchCatalogVersion = () => {
  const context = useContext(ClientAuthContext);
  const onFetchCurrentVersion = (index: number) => {
    return onFetchVersion(context?.user, index);
  };
  return { onFetchCurrentVersion };
};
